import { Route, Redirect, Switch } from "react-router-dom";
import { useRecoilValue } from "recoil";

import rootRedirectPathState from "../../states/rootRedirectPathState";

import MenuItemManage from "../screens/MenuItemManage";
import MenuSetManage from "../screens/MenuSetManage";
import TopMenuItemManage from "../screens/TopMenuItemManage";
import SubMenuItemManage from "../screens/SubMenuItemManage";
import UserManage from "../screens/UserManage";
import RoleManage from "../screens/RoleManage";
import RoleSet from "../screens/RoleSet";
import RoleSetDetail from "../screens/RoleSetDetail";
import ApprovalTypeManage from "../screens/ApprovalTypeManage";
import ApproverManage from "../screens/ApproverManage";
import ApprovalPathManage from "../screens/ApprovalPathManage";
import ApprovalHistory from "../screens/ApprovalHistory";
import ApprovalPathDetailManage from "../screens/ApprovalPathDetailManage";
import ItemUnit from "../screens/ItemUnit";
import ItemType from "../screens/ItemType";
import ItemSpec from "../screens/ItemSpec";
import Item from "../screens/Item";
import Vendor from "../screens/Vendor";
import Customer from "../screens/Customer";
import WorkerPerformanceManage from "../screens/WorkerPerformanceManage";
import ProductPerformanceManage from "../screens/ProductPerformanceManage";
import MaterialIoManage from "../screens/MaterialIoManage";
import MaterialInventoryManage from "../screens/MaterialInventoryManage";
import ConsumablesIoManage from "../screens/ConsumablesIoManage";
import ConsumablesInventoryManage from "../screens/ConsumablesInventoryManage";
import ProductInOutput from "../screens/ProductInOutput";
import ProductInventory from "../screens/ProductInventory";
import AccessControlTarget from "../screens/AccessControlTarget";
import AccessControlRule from "../screens/AccessControlRule";
import Tenant from "../screens/Tenant";
import DbConf from "../screens/DbConf";
import Namespace from "../screens/Namespace";
import Translation from "../screens/Translation";
import TenantLogo from "../screens/TenantLogo";
import SupportedLanguage from "../screens/SupportedLanguage";
import MomSysDecisionCode from "../screens/MomSysDecisionCode";

import MenuRedirector from "../functional/MenuRedirector";

/* Mom Sys Screens */
import MomSysMstProcess from "../screens/MomSysMstProcess";
import MomSysBomBopInfo from "../screens/MomSysBomBopInfo";

import MomSysUdtLineNo from "../screens/MomSysUdtLineNo";
import MomSysUdtWorkStation from "../screens/MomSysUdtWorkStation";
import MomSysUdtWareHouse from "../screens/MomSysUdtWareHouse";
import MomSysUdtCompanyManager from "../screens/MomSysUdtCompanyManager";
import MomSysUdtMaterialType from "../screens/MomSysUdtMaterialType";
import MomSysMstMaterialInfo from "../screens/MomSysMstMaterialInfo";
import MomSysMachineMainType from "../screens/MomSysMachineMainType";
import MomSysMachine from "../screens/MomSysMachine";
import MomSysMachineMain from "../screens/MomSysMachineMain";
import MomSysUglOrderBuyerMst from "../screens/MomSysUglOrderBuyerMst";
import MomSysUglOrderPurchaseMst from "../screens/MomSysUglOrderPurchaseMst";
import MomSysCompanyCollection from "../screens/MomSysCompanyCollection";
import MomSysCollectionsReport from "../screens/MomSysCollectionsReport";
import MomSysMaterialError from "../screens/MomSysMaterialError";
import MomSysMaterialInput from "../screens/MomSysMaterialInput";
import MomSysMaterialOutSourcing from "../screens/MomSysMaterialOutSourcing";
import MomSysMaterialBackShip from "../screens/MomSysMaterialBackShip";
import MomSysMergeSplitHistory from "../screens/MomSysMergeSplitHistory";
import MomSysProductionErrorHistory from "../screens/MomSysProductionErrorHistory";
import MomSysLotStateChange from "../screens/MomSysLotStateChange";
import MomSysBopHistory from "../screens/MomSysBopHistory";
import MomSysBomHistory from "../screens/MomSysBomHistory";
import MomSysSoProduction from "../screens/MomSysSoProduction";
import MomSysMatProduction from "../screens/MomSysMatProduction";
import MomSysStockTakingMst from "../screens/MomSysStockTakingMst";
import MomSysProductionStatus from "../screens/MomSysProductionStatus";
import MomSysProductStatus from "../screens/MomSysProductStatus";
import MomSysMaterialStatus from "../screens/MomSysMaterialStatus";
import MomSysCodeGenerate from "../screens/MomSysCodeGenerate";
import MomSysLotTransHistory from "../screens/MomSysLotTransHistory";
import MomSysLotTrace from "../screens/MomSysLotTrace";
import MomSysProductionCancelHistory from "../screens/MomSysProductionCancelHistory";
import MomSysMaterialByCompany from "../screens/MomSysMaterialByCompany";
import MomSysProcessTime from "../screens/MomSysProcessTime";
import MomSysProductionTime from "../screens/MomSysProductionTime";
import MomSysProcessReport from "../screens/MomSysProcessReport";
import MomSysProductionReport from "../screens/MomSysProductionReport";
import MomSysOwnCompanyManager from "../screens/MomSysOwnCompanyManager";
import MomSysCollectionsDetail from "../screens/MomSysCollectionsDetail";
import DefaultOption from "../screens/DefaultOption";
import RoleSetOption from "../screens/RoleSetOption";
import TenantOption from "../screens/TenantOption";
import TenantTranslation from "../screens/TenantTranslation";
import RoleSetTranslation from "../screens/RoleSetTranslation";
import TranslationValue from "../screens/TranslationValue";
import MomSysSalesCollections from "../screens/MomSysSalesCollections";
import MomSysPurchaseExpense from "../screens/MomSysPurchaseExpense";
import MomSysProductStockTakingMst from "../screens/MomSysProductStockTakingMst";
import MomSysMaterialStockTakingMst from "../screens/MomSysMaterialStockTakingMst";
import MomSysProductInputStatus from "../screens/MomSysProductInputStatus";
import InBox from "../screens/InBox";
import MsgSent from "../screens/MsgSent";
import Trash from "../screens/Trash";
import MomSysDelivery from "../screens/MomSysDelivery";
import MomSysProductShip from "../screens/MomSysProductShip";
import MomSysInspectionEntity from "../screens/MomSysInspectionEntity";
import ProductionPlan from "../screens/ProductionPlan";
import TkPopNotice from "../screens/TkPopNotice";
import MomSysSalesAnalysis from "../screens/MomSysSalesAnalysis";
import MomSysPurchaseAnalysis from "../screens/MomSysPurchaseAnalysis";
import MomSysWageRate from "../screens/MomSysWageRate";
import VwPerformanceMetric from "../screens/VwPerformanceMetric";
import HolidayManage from "../screens/Holiday";
import AdditionalWorkDayManage from "../screens/AdditionalWorkDay";
import WorkDayManage from "../screens/WorkDay";
import WorkerDayOfWeekCapacityManage from "../screens/WorkerDayOfWeekCapacity";
import WorkerDateCapacityManage from "../screens/WorkerDateCapacity";
import MachineDateCapacityManage from "../screens/MachineDateCapacity";
import DefaultWorkerDayOfWeekCapacityManage from "../screens/DefaultWorkerDayOfWeekCapacity";
import DefaultMachineCapacityManage from "../screens/DefaultMachineCapacity";
import MomSysCostAnalysis from "../screens/MomSysCostAnalysis";
import MrpMaterialList from "../screens/MrpMaterialList";
import TkOutSourcingPurchase from "../screens/TkOutSourcingPurchase";
import TkOutSourcingShip from "../screens/TkOutSourcingShip";
import TkOutSourcingInputInspection from "../screens/TkOutSourcingInputInspection";

import LoginNotice from "../screens/LoginNotice";
import MomSysInputInspection from "../screens/MomSysInputInspection";
import TkCustomerSupplyInputInspection from "../screens/TkCustomerSupplyInputInspection";
import TkPopProductManage from "../screens/TkPopProductManage";
import TkTotalAmountCalculation from "../screens/TkTotalAmountCalculation";
import TkMaterialInputStatus from "../screens/TkMaterialInputStatus";
import TkInsertStandardUnitPrice from "../screens/TkInsertStandardUnitPrice";

import TkPartnerPriceAgreement from "../screens/TkPartnerPriceAgreement";
import TkAgreementManagement from "../screens/TkAgreementManagement";
import TkPartnerProcessCost from "../screens/TkPartnerProcessCost";
import TkMaterialAttribute from "../screens/TkMaterialAttribute";
import TkProcessFactorCost from "./../screens/TkProcessFactorCost";
import TkElectrodeOrderPurchaseMst from "../screens/TkElectrodeOrderPurchaseMst";
import TkWrappingStandardUnitPrice from "../screens/TkWrappingStandardUnitPrice";
import TkWrappingVDUnitPrice from "../screens/TkWrappingVDUnitPrice";
import TkProcessSelectionByOrder from './../screens/TkProcessSelectionByOrder';
import TkProcessTemplete from './../screens/TkProcessTemplete';

function ComponentRouter(props) {
    const rootRedirectPath = useRecoilValue(rootRedirectPathState);

    return (
        <>
            <Route exact path="/">
                <Redirect to={rootRedirectPath} />
            </Route>
            <MenuRedirector />
            <Switch>
                {/* Screens */}

                <Route path="*/menuItem" render={() => <MenuItemManage />} />
                <Route path="*/menuSet" render={() => <MenuSetManage />} />
                <Route path="*/topMenuItem" render={() => <TopMenuItemManage />} />
                <Route path="*/subMenuItem" render={() => <SubMenuItemManage />} />

                {/* top menu path가 sub menu path로도 사용되는 경우에는 해당 sub menu path를 가장 아래 두어야 함. role을 유저 아래로 선택하는 경우 /user/role path도 /user/user로 라우팅됨 */}

                <Route path="*/role" render={() => <RoleManage />} />
                <Route path="*/roleset" render={() => <RoleSet />} />
                <Route path="*/rolesetdetail" render={() => <RoleSetDetail />} />
                <Route path="*/user" render={() => <UserManage />} />

                <Route path="*/approvalType" render={() => <ApprovalTypeManage />} />
                <Route path="*/approver" render={() => <ApproverManage />} />
                <Route path="*/approvalPath" render={() => <ApprovalPathManage />} />
                <Route path="*/approvalHistory" render={() => <ApprovalHistory />} />
                <Route path="*/approvalPathDetail" render={() => <ApprovalPathDetailManage />} />

                <Route path="*/materialIo" render={() => <MaterialIoManage />} />
                <Route path="*/materialInventory" render={() => <MaterialInventoryManage />} />
                <Route path="*/consumablesIo" render={() => <ConsumablesIoManage />} />
                <Route path="*/consumablesInventory" render={() => <ConsumablesInventoryManage />} />

                <Route path="*/item" render={() => <Item />} />
                <Route path="*/itemUnit" render={() => <ItemUnit />} />
                <Route path="*/itemType" render={() => <ItemType />} />
                <Route path="*/itemSpec" render={() => <ItemSpec />} />
                <Route path="*/vendor" render={() => <Vendor />} />
                <Route path="*/customer" render={() => <Customer />} />

                <Route path="*/workerPerformance" render={() => <WorkerPerformanceManage />} />
                <Route path="*/productPerformance" render={() => <ProductPerformanceManage />} />

                <Route path="*/productIo" render={() => <ProductInOutput />} />
                <Route path="*/productInventory" render={() => <ProductInventory />} />

                <Route path="*/accessControlTarget" render={() => <AccessControlTarget />} />
                <Route path="*/accessControlRule" render={() => <AccessControlRule />} />

                <Route path="*/dbconf" render={() => <DbConf />} />
                <Route path="*/namespace" render={() => <Namespace />} />
                <Route path="*/language" render={() => <SupportedLanguage />} />
                <Route path="*/translation" render={() => <Translation />} />
                <Route path="*/tenantLogo" render={() => <TenantLogo />} />
                <Route path="*/defaultOption" render={() => <DefaultOption />} />
                <Route path="*/roleSetOption" render={() => <RoleSetOption />} />
                <Route path="*/tenantOption" render={() => <TenantOption />} />
                <Route path="*/tenant" render={() => <Tenant />} />
                <Route path="*/tenantTranslation" render={() => <TenantTranslation />} />
                <Route path="*/roleSetTranslation" render={() => <RoleSetTranslation />} />
                <Route path="*/translationSearch" render={() => <TranslationValue />} />
                <Route path="*/inBox" render={() => <InBox />} />
                <Route path="*/msgSent" render={() => <MsgSent />} />
                <Route path="*/trash" render={() => <Trash />} />

                {/* Mom Sys Screens*/}

                <Route path="*/decisionCode" render={() => <MomSysDecisionCode />} />

                <Route path="*/momSysProcess" render={() => <MomSysMstProcess />} />
                <Route path="*/momSysbombop" render={() => <MomSysBomBopInfo />} />

                <Route path="*/momSysLineNo" render={() => <MomSysUdtLineNo />} />
                <Route path="*/momSysWorkStation" render={() => <MomSysUdtWorkStation />} />
                <Route path="*/momSysWareHouse" render={() => <MomSysUdtWareHouse />} />
                <Route path="*/momSysCompany" render={() => <MomSysUdtCompanyManager />} />
                <Route path="*/momSysMaterialType" render={() => <MomSysUdtMaterialType />} />
                <Route path="*/momSysMaterialInfo" render={() => <MomSysMstMaterialInfo />} />
                <Route path="*/machineMainType" render={() => <MomSysMachineMainType />} />
                <Route path="*/machine" render={() => <MomSysMachine />} />
                <Route path="*/machineMaintenance" render={() => <MomSysMachineMain />} />

                <Route path="*/momSysOrderBuyer" render={() => <MomSysUglOrderBuyerMst />} />
                <Route path="*/momSysOrderPurchase" render={() => <MomSysUglOrderPurchaseMst />} />

                <Route path="*/momSysDelivery" render={() => <MomSysDelivery />} />
                <Route path="*/momSysCompanyCollection" render={() => <MomSysCompanyCollection />} />
                <Route path="*/momSysCollectionsReport" render={() => <MomSysCollectionsReport />} />
                <Route path="*/momSysMaterialError" render={() => <MomSysMaterialError />} />
                <Route path="*/momSysMaterialInput" render={() => <MomSysMaterialInput />} />
                <Route path="*/momSysMaterialOutSourcing" render={() => <MomSysMaterialOutSourcing />} />
                <Route path="*/momSysMaterialBackShip" render={() => <MomSysMaterialBackShip />} />
                <Route path="*/momSysMergeSplitHistory" render={() => <MomSysMergeSplitHistory />} />
                <Route path="*/momSysProductionErrorHistory" render={() => <MomSysProductionErrorHistory />} />
                <Route path="*/momSysMaterialStatus" render={() => <MomSysMaterialStatus />} />

                <Route path="*/momSysInputInspection" render={() => <MomSysInputInspection />} />

                <Route path="*/momSysBopHistory" render={() => <MomSysBopHistory />} />
                <Route path="*/momSysBomHistory" render={() => <MomSysBomHistory />} />
                <Route path="*/momSysSoProduction" render={() => <MomSysSoProduction />} />
                <Route path="*/momSysMatProduction" render={() => <MomSysMatProduction />} />
                <Route path="*/momSysStockTakingMst" render={() => <MomSysStockTakingMst />} />
                <Route path="*/momSysProductionStatus" render={() => <MomSysProductionStatus />} />
                <Route path="*/momSysProductStatus" render={() => <MomSysProductStatus />} />
                <Route path="*/MomSysLotStateChange" render={() => <MomSysLotStateChange />} />
                <Route path="*/momSysCodeGenerate" render={() => <MomSysCodeGenerate />} />
                <Route path="*/momSysLotTransHistory" render={() => <MomSysLotTransHistory />} />
                <Route path="*/momSysLotTrace" render={() => <MomSysLotTrace />} />
                <Route path="*/momSysProductionCancelHistory" render={() => <MomSysProductionCancelHistory />} />
                <Route path="*/momSysMaterialByCompany" render={() => <MomSysMaterialByCompany />} />
                <Route path="*/momSysProcessTime" render={() => <MomSysProcessTime />} />
                <Route path="*/momSysProductionTime" render={() => <MomSysProductionTime />} />
                <Route path="*/momSysProcessReport" render={() => <MomSysProcessReport />} />
                <Route path="*/momSysProductionReport" render={() => <MomSysProductionReport />} />
                <Route path="*/momSysOwnCompany" render={() => <MomSysOwnCompanyManager />} />
                <Route path="*/momSysAdvancePayment" render={() => <MomSysCollectionsDetail advancePayment={true} />} />
                <Route path="*/momSysSalesCollections" render={() => <MomSysSalesCollections />} />
                <Route path="*/momSysPurchaseExpense" render={() => <MomSysPurchaseExpense />} />
                <Route path="*/momSysProductShip" render={() => <MomSysProductShip />} />
                <Route path="*/momSysInspectionEntity" render={() => <MomSysInspectionEntity />} />
                <Route path="*/momSysProductionPlan" render={() => <ProductionPlan />} />
                <Route path="*/tkPopNotice" render={() => <TkPopNotice />} />
                <Route path="*/momSysSalesAnalysis" render={() => <MomSysSalesAnalysis />} />
                <Route path="*/momSysPurchaseAnalysis" render={() => <MomSysPurchaseAnalysis />} />
                <Route path="*/momSysWageRate" render={() => <MomSysWageRate />} />
                <Route path="*/performanceMetric" render={() => <VwPerformanceMetric />} />
                <Route path="*/holiday" render={() => <HolidayManage />} />
                <Route path="*/additionalWorkDay" render={() => <AdditionalWorkDayManage />} />
                <Route path="*/workDay" render={() => <WorkDayManage />} />
                <Route path="*/workerDayOfWeekCapacity" render={() => <WorkerDayOfWeekCapacityManage />} />
                <Route path="*/workerDateCapacity" render={() => <WorkerDateCapacityManage />} />
                <Route path="*/machineDateCapacity" render={() => <MachineDateCapacityManage />} />
                <Route path="*/dayOfWeekCapacity" render={() => <DefaultWorkerDayOfWeekCapacityManage />} />
                <Route path="*/defaultMachineCapacity" render={() => <DefaultMachineCapacityManage />} />
                <Route path="*/momSysCostAnalysis" render={() => <MomSysCostAnalysis />} />

                <Route path="*/momSysProductStockMgmt" render={() => <MomSysProductStockTakingMst />} />
                <Route path="*/momSysMaterialStockMgmt" render={() => <MomSysMaterialStockTakingMst />} />
                <Route path="*/momSysProductInputStatus" render={() => <MomSysProductInputStatus />} />

                <Route path="*/eguUserInformationManage" render={() => <UserManage />} />
                <Route path="*/eguUserGroupManage" render={() => <RoleManage />} />

                {/* TK Screens*/}
                <Route path="*/tkOutSourcingPurchase" render={() => <TkOutSourcingPurchase />} />
                <Route path="*/tkCustomerSupplyInputInspection" render={() => <TkCustomerSupplyInputInspection />} />
                <Route path="*/tkOutSourcingShip" render={() => <TkOutSourcingShip />} />
                <Route path="*/tkOutSourcingInputInspection" render={() => <TkOutSourcingInputInspection />} />
                <Route path="*/tkTotalAmountCalculation" render={() => <TkTotalAmountCalculation />} />
                <Route path="*/tkAgreementManagement" render={() => <TkAgreementManagement />} />
                <Route path="*/tkMaterialInputStatus" render={() => <TkMaterialInputStatus />} />
                <Route path="*/tkInsertStandardUnitPrice" render={() => <TkInsertStandardUnitPrice />} />
                <Route path="*/tkPartnerPriceAgreement" render={() => <TkPartnerPriceAgreement />} />
                <Route path="*/tkPartnerProcessCost" render={() => <TkPartnerProcessCost />} />
                <Route path="*/tkMaterialAttribute" render={() => <TkMaterialAttribute />} />
                <Route path="*/tKProcessFactorCost" render={() => <TkProcessFactorCost />} />

                <Route path="*/tkElectrodeOrderPurchaseMst" render={() => <TkElectrodeOrderPurchaseMst />} />
                <Route path="*/tkWrappingStandardUnitPrice" render={() => <TkWrappingStandardUnitPrice />} />
                <Route path="*/tkWrappingVDUnitPrice" render={() => <TkWrappingVDUnitPrice />} />
                <Route path="*/tkProcessTemplete" render={() => <TkProcessTemplete />} />
                <Route path="*/tkProcessSelectionByOrderBuyerDetail" render={() => <TkProcessSelectionByOrder />} />

                <Route path="*/mrpMaterialList" render={() => <MrpMaterialList />} />

                <Route path="*/popAll" render={() => <TkPopProductManage id="PopAll" />} />
                <Route path="*/popMilling" render={() => <TkPopProductManage id="Milling" />} />
                <Route path="*/popGrinding" render={() => <TkPopProductManage id="Grinding" />} />
                <Route path="*/popNc" render={() => <TkPopProductManage id="Nc" />} />
                <Route path="*/popWire" render={() => <TkPopProductManage id="Wire" />} />
                <Route path="*/popElectrodeProcessing" render={() => <TkPopProductManage id="ElectrodeProcessing" />} />
                <Route path="*/popEdm" render={() => <TkPopProductManage id="Edm" />} />
                <Route path="*/popWrapping" render={() => <TkPopProductManage id="Wrapping" />} />
                <Route path="*/popMeasurement" render={() => <TkPopProductManage id="Measurement" />} />

                {/* LoginNotice Screen */}
                <Route path="*/loginNotice" render={() => <LoginNotice />} />

                {/* Default Redirect */}

                <Route path="*">
                    <Redirect to="/" />
                </Route>
            </Switch>
        </>
    );
}

export default ComponentRouter;
